import React, { useState } from 'react'
import { SingleDatePicker } from 'react-dates'
import 'react-dates/lib/css/_datepicker.css'
import 'react-dates/initialize'

import moment from 'moment'
import { useIntl } from 'react-intl'
import { IconCalendar } from '@contrast-security-inc/design-system-foundations'
import { css } from '@emotion/css'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { useOrganization } from '../../../../organization-licenses/api/use-organization'
import { getOrgUuid } from '../../../../add-agent/download-agent/wizard/common/utils'

dayjs.extend(utc)
dayjs.extend(timezone)
export const DateField = ({ field, updateValue }) => {
  const organizationUuid = getOrgUuid()
  const { data } = useOrganization({ organizationUuid })

  const { locale, formatMessage } = useIntl()

  //  Locale is needed for localized date/time stamps
  moment.locale(locale)

  //  Dates are persisted in unix time (seconds) from 1/1/1970 in the form and need to be converted to
  //  milliseconds from 1/1/1970 for the display.
  const initialDate = field.value ? parseInt(field.value, 10) * 1000 : null

  const [date, setDate] = useState(
    initialDate ? dayjs.tz(initialDate, data?.timezone) : null
  )
  const [focused, setFocused] = useState(false)

  //  Dates are shown in (ms) from 1/1/1970 and need to be converted back to unix time for the form / API
  const selectionChanged = (selectedDate) => {
    const parseDateToDayjs = selectedDate
      ? dayjs.tz(selectedDate.toDate(), data?.timezone)
      : null
    setDate(parseDateToDayjs)

    updateValue(parseDateToDayjs ? parseDateToDayjs.unix() : '')
  }
  return (
    <>
      <SingleDatePicker
        date={date ? moment(date.toDate()) : null}
        onDateChange={selectionChanged}
        focused={focused}
        onFocusChange={(event) => setFocused(event.focused)}
        numberOfMonths={1}
        placeholder={formatMessage({ id: 'title_date' })}
      />
      <span
        className={css`
          position: absolute;
          right: 0;
          margin: 4px 4px 0 0;
          pointer-events: none;
        `}
      >
        <IconCalendar size="md" />
      </span>
    </>
  )
}
